import type { Transition } from 'framer-motion'

// Animation
export const TRANSITION_DURATION_IN_SEC = 0.5
export const DEFAULT_TRANSITION: Transition = {
  duration: TRANSITION_DURATION_IN_SEC,
  ease: 'easeOut',
}

// Heights for Card height calculation
export const VEHICLE_MISSION_WAYPOINT_HEADER_HEIGHT = 40
export const VEHICLE_MISSION_WAYPOINT_DESTINATION_HEIGHT = 36
export const VEHICLE_MISSION_WAYPOINT_DESTINATION_DIVIDER_HEIGHT = 1
export const VEHICLE_MISSION_WAYPOINT_ACTION_HEIGHT = 22
export const VEHICLE_MISSION_WAYPOINT_ACTION_MARGIN_HEIGHT = 8
export const AD_VEHICLE_MISSION_WAYPOINT_ACTION_STATE_HEIGHT = 50
export const VEHICLE_MISSION_WAYPOINT_MARGIN_BOTTOM_HEIGHT = 8
export const VEHICLE_MISSION_WAYPOINT_DIVIDER_HEIGHT = 1
export const VEHICLE_MISSION_WAYPOINT_EXPANDER_HEIGHT = 65
